import React from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { useMsal } from '@azure/msal-react';
import {
    MaintainanceContainer,
    Header,
    Reason,
    Text,
    Wrapper,
    ButtonText,
    ImageContainer,
    Image,
} from './index.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import Logout2 from 'src/assets/images/Logout2.svg';
import EngineeringwhiteDesktop from 'src/assets/images/EngineeringwhiteDesktop.svg';
import MedtronicWhite from 'src/assets/images/MedtronicWhite.svg';
import { logout as logoutAPI } from 'src/common/redux/actions';
import {
    checkImpersonationActive,
    checkProxyActive,
    logoutWithCleanUp,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
 
const Maintainance = () => {
    const { instance } = useMsal();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));

    useEffectWithErrorLogging(() => {
        document.body.style.overflow = 'hidden';
    }, []);

    const clicked = () => {
        logoutWithCleanUp(instance, dispatch, logoutAPI);
        location.reload();
    };

    const mainTainanceArray =
        !checkProxyActive() &&
        !checkImpersonationActive() &&
        (bannerInfo || []).filter(
            (item) => item.messageType === 'userDestructiveMessage'
        );
    const maintainanceObj =
        mainTainanceArray.length > 0 ? mainTainanceArray[0] : {};
    const { urgentText = '', descriptionText = '' } = maintainanceObj;
    let descText = descriptionText.replaceAll('<pre>', '<p>');
    descText = descText.replaceAll('</pre>', '</p>');
    descText = descText.replaceAll('&nbsp;', ' ');
    descText = descText.replaceAll('&quot;', '"');
    descText = descText.replaceAll('<a', '<a target="_blank"');

    let urgText = urgentText.replaceAll('<pre>', '<p>');
    urgText = urgText.replaceAll('</pre>', '</p>');
    urgText = urgText.replaceAll('&nbsp;', ' ');
    urgText = urgText.replaceAll('&quot;', '"');
    urgText = urgText.replaceAll('<a', '<a target="_blank"');

    // if (Object.values(maintainanceObj).length === 0) {
    //     return null;
    // }

    return (
        <MaintainanceContainer>
            <ImageContainer
                width={'338px'}
                height={'322px'}
                mbWidth={'228px'}
                mbHeight={'84px'}
            >
                <Image
                    src={EngineeringwhiteDesktop}
                    mbWidth={'80px'}
                    mbHeight={'80px'}
                    width={'256px'}
                    height={'256px'}
                ></Image>
            </ImageContainer>
            <Wrapper>
                <Header>
                    <img
                        src={MedtronicWhite}
                        style={{ width: '65%', height: '24px' }}
                    />
                </Header>
                <Reason>{ReactHtmlParser(urgText)}</Reason>
                <Text>{ReactHtmlParser(descText)}</Text>
                <Button
                id={'common-maintainance-logoutButton'}
                    show={true}
                    width={isLanguageChanged ?'fit-content':'119px'}
                    height={'36px'}
                    margin={'20px 0 0 0'}
                    //secondary
                    // variant={ButtonStyles?.secondary}
                    backgroundColor={'#140f4b'}
                    color={'#ffffff'}
                    border={'1px solid #ffffff'}
                    clicked={clicked}
                >
                    <div
                        style={{ margin: '5px 10px 0 5px', cursor: 'pointer' }}
                    >
                        <img src={Logout2}></img>
                    </div>
                    <ButtonText>{t('common.logoutButton')}</ButtonText>
                </Button>
            </Wrapper>
        </MaintainanceContainer>
    );
};
export default Maintainance;
